module.exports = __webpack_public_path__ + "static/media/01_cell_proliferation.5fee3d04.png";